import type { Accept } from "react-dropzone";

export const DFY_IMAGE_ACCEPT: Accept = {
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
  "image/webp": [".webp"],
};

// Matches the backend multer limit for DFY source-image uploads.
export const DFY_MAX_UPLOAD_BYTES = 50 * 1024 * 1024;
